import { Injectable } from '@angular/core';
import { SchedulerListService } from '../../../../common/scheduler/components/list/list.service';
import { ApiRouteTransactionDto } from '../../../../api/elite/dto/purchase-order.dto';
import { AssemblyItem } from '../../../../api/elite/types/assembly-item';
import { orderByRank } from '../../../../common/drag-drop/utils/order-by-rank';
// import { PackingBoxTableRow } from '../../models/table-row';
import {PackingBoxSalesOrderItem} from '../../../../common/packing-box/models/sales-orders';

@Injectable()
export class PackingBoxSalesOrderRankListService extends SchedulerListService<PackingBoxSalesOrderItem> {
  salesOrdersToModify(): { id: number; rank: string }[] {
    return this._list.value
      .filter((item) => item.isInserted && item.rank !== item.previousRank)
      .map((item) => ({
        id: item.id,
        rank: item.rank,
      }));
  }

  firstRank(): PackingBoxSalesOrderItem {
    return orderByRank(this._list.value)[0];
  }

  salesOrderToInsert(
    assemblyItem: AssemblyItem
  ): ApiRouteTransactionDto['insert']['body'][] {
    const lineItems = this._list.value
      .filter((item) => !item.isInserted && item.rank !== item.previousRank)
      .map((item) => ({
        transactionId: item.transactionId,
        title: item.title,
        typeOfTransaction: 'Sales Order',
        salesOrderDetails: {
          customerId: item.customerId,
          customerName: item.customerName,
        },
        dueDate: item.dueDate,
        line: {
          lineId: item.lineId,
          quantityAsked: item.quantityAsked,
          assemblyItemId: item.assemblyItemId,
          rank: item.rank,
          assemblyItem,
          salesOrderLineDetails: {
            partNumberByCustomer: item.partNumberByCustomer,
          },
        },
      })) as ApiRouteTransactionDto['insert']['body'][];
    const salesOrder: ApiRouteTransactionDto['insert']['body'][] = [];
    lineItems.forEach((row) => {
      const transaction = salesOrder.find(
        (t) => t.transactionId === row.transactionId
      );
      if (transaction && Array.isArray(transaction.line)) {
        transaction.line.push(Array.isArray(row.line) ? row.line[0] : row.line);
      } else {
        salesOrder.push({
          ...row,
          line: Array.isArray(row.line) ? row.line : [row.line],
        });
      }
    });
    return salesOrder;
  }
}
